import { QuestionAnswerOutlined } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { format } from "date-fns";
import { isEmpty, map } from "lodash";
import { useQuery } from "react-query";
import { getAnswersForm } from "../../services/forms";
import { CountUp } from "../CountUp";
import { Table } from "../Table";
import { useStyles } from "./styles";

type FormAnswersProps = {
  idForm: number;
  idField: number;
};

export function FormAnswers({ idField, idForm }: FormAnswersProps) {
  const styles = useStyles();
  const answersAndCount = useQuery(
    ["answersAndCount", idField, idForm],
    async () => {
      const response = await getAnswersForm(idField, idForm);
      return response;
    },
    {
      enabled: Boolean(idField) && Boolean(idForm),
    }
  );

  if (answersAndCount.isLoading) {
    return (
      <div className={styles.rootLoading}>
        <CircularProgress size={22} thickness={4} />
      </div>
    );
  }

  if (
    isEmpty(answersAndCount.data?.answers) ||
    isEmpty(answersAndCount.data?.count)
  ) {
    return (
      <Typography textAlign="center" fontWeight={500}>
        Não encontramos nenhuma resposta para essa questão
      </Typography>
    );
  }

  return (
    <>
      <div className={styles.rootContentCard}>
        {map(answersAndCount.data?.count, (count: any) => {
          return (
            <Card className={styles.rootCard} variant="outlined">
              <Typography
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontWeight={500}
              >
                <QuestionAnswerOutlined />
                &nbsp;{count.resposta}
              </Typography>
              <CountUp align="center" end={count.quantidade} />
            </Card>
          );
        })}
      </div>
      <Table
        style={{ width: "100%" }}
        toolbar={false}
        data={answersAndCount.data?.answers as []}
        columns={[
          {
            title: "Documento",
            field: "documento",
            emptyValue: "Não informado",
          },
          { title: "Resposta", field: "resposta" },
          {
            title: "Data",
            field: "data_resposta",
            render: (row) =>
              format(
                new Date(row.data_resposta?.replace("Z", "")),
                "dd/MM/yyyy HH:mm"
              ),
          },
          { title: "Endereço IP", field: "ip_resposta" },
        ]}
        options={{
          actionsColumnIndex: -1,
          pageSize: 3,
          selectionProps: () => ({ color: "primary" }),
        }}
      />
    </>
  );
}
